import React, { useState } from 'react'
import Stepper from 'react-stepper-horizontal'
import UploadFile from './Step1/Step1'
import OtherDetails from './Step2/Step2'

/**
 * STEP 0
 * Component for uploading and validating Excel files for uploaded material master.
 * 
 * @param {Array<Object>} otherMasterList - all material master data
 * @param {React.SetStateAction} setOtherMasterList - setter for material master data
 * @param {string} company_id - company id
 * @returns {JSX.Element}
 */
const OtherUploadExcel = ({ otherMasterList, setOtherMasterList, company_id, superAdmins, emailTemplate, selectedOrg = "company", fetchMaterialMaster }) => {
    const [step, setStep] = useState(0)
    const [uploadedData, setUploadedData] = useState([])
    const [loading, setLoading] = useState(false)

    return (
        <div>
            <Stepper
                steps={[{ title: 'Upload File' },
                { title: 'Check Your Material Details' }]}
                activeStep={step}
                completeColor={'#54a63a'}
                completeTitleColor={'#54a63a'}
                activeColor={'#393186'}
                activeTitleColor={'#393186'}
                titleFontSize={14}
                size={28}
                circleFontSize={14}
            />
            {step === 0 ?
                <UploadFile
                    step={step}
                    setStep={setStep}
                    uploadedData={uploadedData}
                    setUploadedData={setUploadedData}
                    companyID={company_id}
                />
                : null}
            {step === 1 ?
                <OtherDetails
                    selectedOrg={selectedOrg}
                    setLoading={setLoading}
                    loading={loading}
                    emailTemplate={emailTemplate}
                    superAdmins={superAdmins}
                    step={step}
                    setStep={setStep}
                    uploadedData={uploadedData}
                    setUploadedData={setUploadedData}
                    otherMasterList={otherMasterList}
                    setOtherMasterList={setOtherMasterList}
                    company_id={company_id}
                    fetchMaterialMaster={fetchMaterialMaster}
                />
                : null}
        </div>
    )
}

export default OtherUploadExcel
